import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ToolsPage } from './pages/ToolsPage';
import { SDKPage } from './pages/SDKPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="tools/*" element={<ToolsPage />} />
          <Route path="sdk" element={<SDKPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
